export {
  default as fullCourt,
  ReactComponent as FullCourt,
} from '@assets/icons/full-court.svg'
